import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
const FileUploadList = Loadable(lazy(() => import('./FileList')));



const FileRoutes = [	
	{
		path: '/files/list',
		element: <FileUploadList />,
		auth: authRoles.admin,
	}
	
];

export default FileRoutes;
